export function toBoolFieldValue(value: boolean): "True" | "False" {
    return value ? "True" : "False";
}
